import React, { FC } from 'react';
import { Icon, IconButton, Tooltip } from '@kontentino/ui';
import { faComment } from '@fortawesome/pro-regular-svg-icons/faComment';
import { useTranslation } from 'react-i18next';
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';

type Props = {
  onExpand: () => void;
};

const ApprovalCommunicationHeader: FC<Props> = ({ onExpand }) => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-grayscale-10 tw-p-4">
      <div className="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-bg-blueberry-light">
        <Icon icon={faComment} className="tw-text-blueberry-dark" />
      </div>
      <h3 className="tw-text-base tw-font-semibold tw-text-grayscale-180">
        {t('communication.title', 'Communication')}
      </h3>
      <Tooltip content={'See the post details'}>
        <IconButton
          icon={<Icon icon={faArrowUpRight} />}
          variant="plain"
          size="small"
          onClick={onExpand}
          className="tw-ml-auto tw-text-grayscale-100"
          data-name="communication_expand-comments"
        />
      </Tooltip>
    </div>
  );
};

export default ApprovalCommunicationHeader;
